import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "row col-12" }
const _hoisted_2 = { class: "col-lg-12 form-group" }
const _hoisted_3 = { for: "referral-address-line-1" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Address Line 1")
const _hoisted_6 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_7 = { class: "col-lg-12 form-group" }
const _hoisted_8 = { for: "referral-address-line-2" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Address Line 2 ")
const _hoisted_11 = { class: "col-lg-6 form-group" }
const _hoisted_12 = { for: "referral-zip" }
const _hoisted_13 = {
  key: 0,
  class: "badge me-1"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" ZIP")
const _hoisted_15 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_16 = {
  key: 0,
  class: "col-lg-6 form-group"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "referral-zip" }, "ZIP+4 ", -1 /* HOISTED */)
const _hoisted_18 = { class: "col-lg-6 form-group" }
const _hoisted_19 = { for: "referral-county" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" County")
const _hoisted_21 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select County", -1 /* HOISTED */)
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 1,
  disabled: "",
  value: null
}
const _hoisted_25 = { class: "col-lg-6 form-group" }
const _hoisted_26 = { for: "referral-city" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" City ")
const _hoisted_28 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_29 = { for: "referral-state" }
const _hoisted_30 = {
  key: 0,
  class: "badge me-1"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" State")
const _hoisted_32 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select State", -1 /* HOISTED */)
const _hoisted_34 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        (_ctx.addressName)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.addressName), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _hoisted_5,
        (_ctx.isRequired)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "*"))
          : _createCommentVNode("v-if", true)
      ]),
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass(`form-control  ${
                    _ctx.v$.address.AddressLine1.$error || _ctx.getErrors('AddressLine1') ? 'border border-warning' : ''
                }`),
        maxlength: "50",
        type: "text",
        placeholder: "Enter Address Line 1",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.address.AddressLine1) = $event)),
        onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.address.AddressLine1.$touch && _ctx.v$.address.AddressLine1.$touch(...args))),
        onChange: _cache[2] || (_cache[2] = (e) => _ctx.handleAllInputChange('AddressLine1', e.target.value))
      }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
        [_vModelText, _ctx.address.AddressLine1]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", _hoisted_8, [
        (_ctx.addressName)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.addressName), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _hoisted_10
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        maxlength: "50",
        type: "text",
        placeholder: "Enter Address Line 2",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.address.AddressLine2) = $event))
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, _ctx.address.AddressLine2]
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("label", _hoisted_12, [
        (_ctx.showCode)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "M0060"))
          : _createCommentVNode("v-if", true),
        _hoisted_14,
        (_ctx.isRequired)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, "*"))
          : _createCommentVNode("v-if", true)
      ]),
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass(`form-control ${_ctx.v$.address.Zip.$error || _ctx.getErrors('Zip') ? 'border border-warning' : ''}`),
        maxlength: "5",
        type: "text",
        placeholder: "Enter Zip",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.address.Zip) = $event)),
        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleZipChange())),
        onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.v$.address.Zip.$touch && _ctx.v$.address.Zip.$touch(...args)))
      }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
        [_directive_number_only],
        [_vModelText, _ctx.address.Zip]
      ])
    ]),
    (_ctx.showZipFourCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _hoisted_17,
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            maxlength: "4",
            type: "text",
            placeholder: "Enter Zip",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.address.ZipCodeFour) = $event))
          }, null, 512 /* NEED_PATCH */), [
            [_directive_number_only],
            [_vModelText, _ctx.address.ZipCodeFour]
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("label", _hoisted_19, [
        _hoisted_20,
        (_ctx.isCountyRequired)
          ? (_openBlock(), _createElementBlock("span", _hoisted_21, "*"))
          : _createCommentVNode("v-if", true)
      ]),
      _withDirectives(_createElementVNode("select", {
        class: _normalizeClass(`form-select ${_ctx.v$.address.County.$error || _ctx.getErrors('County') ? 'border border-warning' : ''}`),
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.address.County) = $event)),
        onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.v$.address.County.$touch && _ctx.v$.address.County.$touch(...args))),
        onChange: _cache[10] || (_cache[10] = (e) => _ctx.handleAllInputChange('County', e.target.value))
      }, [
        _hoisted_22,
        (_ctx.countyData?.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.countyData, (ctyData, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: ctyData,
                key: index
              }, _toDisplayString(ctyData), 9 /* TEXT, PROPS */, _hoisted_23))
            }), 128 /* KEYED_FRAGMENT */))
          : (_openBlock(), _createElementBlock("option", _hoisted_24, "List is empty"))
      ], 34 /* CLASS, HYDRATE_EVENTS */), [
        [_vModelSelect, _ctx.address.County]
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("label", _hoisted_26, [
        _hoisted_27,
        (_ctx.isRequired)
          ? (_openBlock(), _createElementBlock("span", _hoisted_28, "*"))
          : _createCommentVNode("v-if", true)
      ]),
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass(`form-control ${_ctx.v$.address.City.$error || _ctx.getErrors('City') ? 'border border-warning' : ''}`),
        maxlength: "50",
        type: "text",
        placeholder: "Enter City",
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.address.City) = $event)),
        onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.v$.address.City.$touch && _ctx.v$.address.City.$touch(...args))),
        onChange: _cache[13] || (_cache[13] = (e) => _ctx.handleAllInputChange('City', e.target.value))
      }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
        [_vModelText, _ctx.address.City]
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(`form-group ${_ctx.stateClass ? _ctx.stateClass : 'col-lg-12'}`)
    }, [
      _createElementVNode("label", _hoisted_29, [
        (_ctx.showCode)
          ? (_openBlock(), _createElementBlock("span", _hoisted_30, "M0050"))
          : _createCommentVNode("v-if", true),
        _hoisted_31,
        (_ctx.isRequired)
          ? (_openBlock(), _createElementBlock("span", _hoisted_32, "*"))
          : _createCommentVNode("v-if", true)
      ]),
      _withDirectives(_createElementVNode("select", {
        class: _normalizeClass(`form-select ${_ctx.v$.address.State.$error || _ctx.getErrors('State') ? 'border border-warning' : ''}`),
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.address.State) = $event)),
        onBlur: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.v$.address.State.$touch && _ctx.v$.address.State.$touch(...args))),
        onChange: _cache[16] || (_cache[16] = (e) => _ctx.handleAllInputChange('State', e.target.value))
      }, [
        _hoisted_33,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions?.addressStateCode, (addState, index) => {
          return (_openBlock(), _createElementBlock("option", {
            value: addState.value,
            key: index
          }, _toDisplayString(addState.text), 9 /* TEXT, PROPS */, _hoisted_34))
        }), 128 /* KEYED_FRAGMENT */))
      ], 34 /* CLASS, HYDRATE_EVENTS */), [
        [_vModelSelect, _ctx.address.State]
      ])
    ], 2 /* CLASS */)
  ]))
}